import request from '@/utils/request'

let FriendsApi = {
 /*好友圈列表*/
 friendslist(data) {
  return request._post('/shop/plus.friends.friends/index', data);
},
/*添加好友圈*/
addfriends(data) {
  return request._post('/shop/plus.friends.friends/add', data);
},
/*修改好友圈*/
editfriends(data) {
  return request._post('/shop/plus.friends.friends/edit', data);
},
/*删除好友圈*/
deletefriends(data) {
  return request._post('/shop/plus.friends.friends/delete', data);
},
getFriend(data){
  return request._get('/shop/setting.friend/index', data);
},
setFriend(data){
  return request._post('/shop/setting.friend/index', data);
}
}
export default FriendsApi;



// WEBPACK FOOTER //
// ./src/api/friends.js